import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../Common/Loader";
import { getAboutClubText } from "../../Slice/CommonSlice";
import ReactHtmlParser from "react-html-parser";
const HowItWork = () => {
  const dispatch = useDispatch();
  const { cmsData, isLoading } = useSelector((state) => state.common);
  useEffect(() => {
    dispatch(getAboutClubText(5));
  }, [dispatch]);
  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>How It Works</h2>
            </div>
            <div
              className="accordion ruleaccordion howtoplayaccordion"
              id="accordionExample"
            >
              {cmsData &&
                cmsData.map((item, key) => (
                  <div className="accordion-item">
                    <h2 className="accordion-header" id={`heading${key}`}>
                      <strong>{++key}</strong> {item.text1}
                      <span data-bs-toggle="modal" data-bs-target="#howtoplay">
                        <i className="far fa-image"></i>
                      </span>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${key}`}
                        aria-expanded="false"
                        aria-controls="collapse1"
                      ></button>
                    </h2>
                    <div
                      id={`collapse${key}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${key}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="rulelist">
                          {ReactHtmlParser(item.text2)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowItWork;
